import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchPlatformPackagesArgs,
  FetchOrgInvoicesArgs,
  OrgBillingArgs,
} from '../api/types/payments.types';
import type {
  FreeAnalyticsArgs,
  FetchOrgInvoiceArgs,
  FetchOrgChargesArgs,
  FetchStairChangesArgs,
} from '../api/platformBilling.api';

import {
  fetchOrgBillingOverview,
  fetchPlatformPackages,
  fetchOrgInvoices,
  fetchOrgInvoice,
  fetchOrgCharges,
  fetchOrgNextPayment,
  fetchFreeAnalyticsGrant,
  fetchOrgStairs,
  fetchStairChanges,
} from '../api/platformBilling.api';

export const platformBillingQueryKeys = createQueryKeys('platformBilling', {
  fetchOrgBillingOverview: ({ organizationId }: OrgBillingArgs) => ({
    queryFn: () => fetchOrgBillingOverview({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchOrgInvoices: (args: FetchOrgInvoicesArgs) => ({
    queryFn: () => fetchOrgInvoices(args),
    queryKey: [args.organizationId, args.limit, args.offset],
  }),
  fetchPackages: ({ currency }: FetchPlatformPackagesArgs) => ({
    queryFn: () => fetchPlatformPackages({ currency }),
    queryKey: [currency],
  }),
  fetchOrgInvoice: ({ organizationId, invoiceId }: FetchOrgInvoiceArgs) => ({
    queryFn: () => fetchOrgInvoice({ organizationId, invoiceId }),
    queryKey: [organizationId, invoiceId],
  }),
  fetchOrgCharges: ({
    organizationId,
    limit,
    offset,
  }: FetchOrgChargesArgs) => ({
    queryFn: () => fetchOrgCharges({ organizationId, limit, offset }),
    queryKey: [organizationId, limit, offset],
  }),
  fetchOrgNextPayment: ({ organizationId }: OrgBillingArgs) => ({
    queryFn: () => fetchOrgNextPayment({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchOrgStairs: ({ organizationId }: OrgBillingArgs) => ({
    queryFn: () => fetchOrgStairs({ organizationId }),
    queryKey: [organizationId],
  }),
  fetchStairChanges: ({ tenantId, limit, offset }: FetchStairChangesArgs) => ({
    queryFn: () => fetchStairChanges({ tenantId, limit, offset }),
    queryKey: [tenantId ?? 'mine', limit, offset],
  }),
  // Task 7.2 — the organization's live "Free analytics" grant (platform only)
  fetchFreeAnalyticsGrant: ({ organizationId }: FreeAnalyticsArgs) => ({
    queryFn: () => fetchFreeAnalyticsGrant({ organizationId }),
    queryKey: [organizationId],
  }),
});
